import useCustomHook from '@/hooks/useCustomHook';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { useContext, useEffect } from 'react';
import expandTaskMiniactivities from 'src/modules/activities/expandMiniactivies';

export default function useStudentTaskDetailContent({ task }) {
  const globalContext = useContext(GlobalContext);

  const { state, actions } = useCustomHook({
    defaultState: {
      loading: true,
      task: null,
    },
    actions: {},
  });

  useEffect(() => {
    if (task) {
      task.taskActivities?.sort((a, b) => {
        return a.order - b.order;
      });
      task.taskActivities = expandTaskMiniactivities(task.taskActivities);
      actions.setState({
        task,
        loading: false,
      });
    }
  }, [task]);

  return {
    state: {
      ...state,
      timeOffset: globalContext.state.user?.student?.data?.timeOffset,
    },
    actions,
  };
}
